import { render } from "./Camera.vue?vue&type=template&id=feffefa4&scoped=true&ts=true"
import script from "./Camera.vue?vue&type=script&lang=ts"
export * from "./Camera.vue?vue&type=script&lang=ts"

import "./Camera.vue?vue&type=style&index=0&id=feffefa4&scoped=true&lang=css"

import exportComponent from "C:\\Users\\DELL\\Documents\\vyzor\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-feffefa4"]])

export default __exports__